module.exports = __webpack_public_path__ + "static/media/lock.793e211c.svg";